module.exports = __webpack_public_path__ + "static/media/youtubemusic.865fb3e6.svg";